<template>
  <div id="app">
    <router-link to="/" />
    <router-view />
  </div>
</template>
<script>
export default {
  components: {},
  computed: {},
};
</script>
<script setup></script>
<style>
* {
  margin: 0;
  padding: 0;
  border: 0;
  text-align: center;
  box-sizing: border-box;
  /* 定义滚动条的宽度 */
  ::-webkit-scrollbar {
    width: 2px;
  }

  /* 定义滚动条轨道的样式 */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* 定义滚动条的样式 */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* 定义滚动条在鼠标悬停时的样式 */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f9fafb;
  height: 100vh;
  width: 100vw;
}
</style>
